import script from "./NativeDateInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NativeDateInput.vue?vue&type=script&setup=true&lang=js"

import "./NativeDateInput.vue?vue&type=style&index=0&id=71dabf5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71dabf5a"]])

export default __exports__